import { useParams } from '@tanstack/react-router';

export function useChannelSlug(): string | undefined {
  const { channelSlug } = useParams({ strict: false });
  return channelSlug || undefined;
}
